"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactHelmetAsync = require("react-helmet-async");

var _scriptBuilder = _interopRequireDefault(require("../scriptBuilder"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const HelmetWrapper = _ref => {
  let {
    writeKey,
    integrations,
    version,
    culture,
    tenant
  } = _ref;
  return /*#__PURE__*/React.createElement(_reactHelmetAsync.Helmet, {
    defer: true
  }, /*#__PURE__*/React.createElement("script", {
    type: "text/javascript"
  }, (0, _scriptBuilder.default)(writeKey, integrations, version, culture, tenant)));
};

HelmetWrapper.propTypes = {
  tenant: _propTypes.default.string.isRequired,
  culture: _propTypes.default.string.isRequired,
  integrations: _propTypes.default.object,
  version: _propTypes.default.string,
  writeKey: _propTypes.default.string
};
var _default = HelmetWrapper;
exports.default = _default;